import { useAuth } from '@/hooks/use-auth';
import React from 'react';

/**
 * Auth权限组件
 * @param {string} code - 权限代码
 * @param {React.ReactNode} children - 有权限时渲染的内容
 * @returns {React.ReactNode|null} - 有权限返回children，无权限返回null
 */
export const Auth = ({ code, children, fullback = null }) => {
    const hasPermission = useAuth(code);
    // 有权限返回children，无权限返回null
    return hasPermission ? children : fullback;
};

export default Auth;
